import React from "react";

import Experience from "./experience";

export default ({ experience, sectionName, heading }) => (
  <section
    className="colorlib-experience"
    data-section={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
    id={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
  >
    <div className="colorlib-narrow-content">
      <div className="row">
        <div className="col-md-6 col-md-offset-3 col-md-pull-3">
          <span className="heading-meta">{sectionName}</span>
          <h2 className="colorlib-heading">{heading}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="timeline-centered">
            {experience.map(item => (
              <Experience {...item} key={item.character + item.dates} />
            ))}
            <article className="timeline-entry begin">
              <div className="timeline-entry-inner">
                <div className="timeline-icon color-none" />
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/experienceContainer.js